import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BuildInfo } from '@iot-platform/models/common';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  getCurrentVersion(): Observable<string> {
    return this.httpClient.get<BuildInfo>('assets/data/build.json').pipe(map((data: BuildInfo) => data.version));
  }

  getChangelog(): Observable<any> {
    return this.httpClient.get('assets/data/CHANGELOG.md', { responseType: 'text' }).pipe(catchError(() => of(null)));
  }
}
